<template>

    <div id="dashboard">
        <section id="content">
            <!--start container-->
            <div class="container">
                <TituloPagina titulo="Acesso restrito" />
                <p>Você não tem acesso a essa funcionalidade do sistema, por favor entre em contato com a Segasp.</p>
            </div>
            <!--end container-->
        </section>

  </div>
</template>
<script>
    import TituloPagina from '@/components/common/TituloPagina';

    export default {
        components: {
            TituloPagina

        },
        data: () => ({
        }),
        created() {
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/auth/Page403.vue